import { updateRecordInStore } from 'utils/redux';
import { ability, updateAbilityWithPerm } from 'utils/permissions';

import {
  CREATE_CAMPAIGN_PENDING,
  CREATE_CAMPAIGN_FAIL,
  CREATE_CAMPAIGN_SUCCESS,
  GET_CAMPAIGN_PENDING,
  GET_CAMPAIGN_FAIL,
  GET_CAMPAIGN_SUCCESS,
  UPDATE_CAMPAIGN_PENDING,
  UPDATE_CAMPAIGN_FAIL,
  UPDATE_CAMPAIGN_SUCCESS,
  GET_CAMPAIGNS_PENDING,
  GET_CAMPAIGNS_FAIL,
  GET_CAMPAIGNS_SUCCESS,
  GET_CLIENT_CAMPAIGNS,
  DUPLICATE_CAMPAIGN,
  UPDATE_CREATE_CAMPAIGN_STATE,
  RESET_CAMPAIGN,
} from '../actions/campaignActions';


const initialState = {
  campaign: {
    loading: false,
    loaded: true,
    name: null,
    status: null,
    account: null,
    products: null,
    launch_date: null,
    campaign_manager: null,
    subscription: null,
    errors: null,
    stat_people: null,
    stat_opens: null,
    stat_unique_opens: null,
    stat_delivered: null,
    stat_replies: null,
    stat_unique_replies: null,
    response_email_forwards: null,
    inbox_visible: null,
  },
  campaigns: {
    loading: false,
    loaded: false,
    count: null,
    next: null,
    previous: null,
    results: [],
    errors_count: 0,
    total_people: 0,
    total_delivered: 0,
    interested_sum: 0,
    opens_sum: 0,
    replies_sum: 0,
  },
  clientCampaigns: {
    loading: false,
    loaded: true,
    count: null,
    next: null,
    previous: null,
    results: [],
    errors_count: 0,
    total_people: 0,
    total_delivered: 0,
    interested_sum: 0,
    opens_sum: 0,
    replies_sum: 0,
  },
  createCampaignState: {
    openCampaignBuilder: false,
    openSequenceBuilder: false,
    openAddEmailConfig: false,
  },
};


export const campaignReducer = (state = initialState.campaign, action) => {
  switch (action.type) {
    case CREATE_CAMPAIGN_PENDING:
      return {
        loading: true,
        loaded: false,
      };
    case CREATE_CAMPAIGN_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case CREATE_CAMPAIGN_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_CAMPAIGN_PENDING:
      return {
        loading: true,
        loaded: false,
      };
    case GET_CAMPAIGN_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_CAMPAIGN_SUCCESS:
      if (action.payload.inbox_visible) {
        updateAbilityWithPerm(ability, {
          action: 'see',
          subject: 'Campaign Inbox',
        });
      }
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_CAMPAIGN_PENDING:
      return {
        ...state,
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case UPDATE_CAMPAIGN_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_CAMPAIGN_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case DUPLICATE_CAMPAIGN.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case DUPLICATE_CAMPAIGN.success:
      return {
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case DUPLICATE_CAMPAIGN.error:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case RESET_CAMPAIGN:
      return {
        ...initialState.campaign,
      };
    default:
      return state;
  }
};


export const campaignsReducer = (state = initialState.campaigns, action) => {
  switch (action.type) {
    case GET_CAMPAIGNS_PENDING:
      return {
        ...state,
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case GET_CAMPAIGNS_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_CAMPAIGNS_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_CAMPAIGN_SUCCESS:
      return {
        loading: false,
        loaded: true,
        results: updateRecordInStore(
          r => r.id === action.payload.id,
          state.results,
          action.payload,
        ),
      };
    default:
      return state;
  }
};


export const clientCampaignsReducer = (state = initialState.clientCampaigns, action) => {
  switch (action.type) {
    case GET_CLIENT_CAMPAIGNS.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case GET_CLIENT_CAMPAIGNS.error:
      return {
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case GET_CLIENT_CAMPAIGNS.success:
      return {
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    default:
      return state;
  }
};

export const createCampaignStateReducer = (state = initialState.createCampaignState, action) => {
  switch (action.type) {
    case UPDATE_CREATE_CAMPAIGN_STATE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
